
<div class="customer-dashboard">
  <h1>Tableau de bord </h1>
  <mat-accordion multi>

    <mat-expansion-panel expanded>
      <mat-expansion-panel-header>
        <mat-panel-title>
          <h5>Mes Achats </h5>
          <!-- <button class="simple-button" mat-button routerLink="/buy/search">
          <mat-icon>search</mat-icon> Rechercher
        </button> -->

      </mat-panel-title>
    </mat-expansion-panel-header>

    @if (dealerData != undefined) {
      <div>
        <h6><a [routerLink]="['/customer/buy']" >Mes achats en cours</a></h6>
        <h6><a [routerLink]="['/customer/buy']" >Mes achats complétés</a></h6>
        <h6><a [routerLink]="['/customer/favorites']" >Mes Favoris</a></h6>
        <h6><a [routerLink]="['/customer/alerts']" >Mes Alertes</a></h6>
        <!-- <h6><a [routerLink]="['/customer/buy']" fragment="alerts" >Mes alertes({{dealerData.alerts!.length}})</a></h6> -->
      </div>
    }
  </mat-expansion-panel>

  <mat-expansion-panel expanded>
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h5>Mes Locations </h5>
        <!-- <button class="simple-button" mat-button routerLink="/rent/search">
        <mat-icon>search</mat-icon> Rechercher
      </button> -->

    </mat-panel-title>
  </mat-expansion-panel-header>

  @if (dealerData != undefined) {
    <div>
      <h6><a [routerLink]="['/customer/rent']">Réservations</a></h6>
      <h6><a [routerLink]="['/customer/rent']">Locations en cours </a></h6>
      <h6><a [routerLink]="['/customer/rent']">Locations complétées </a></h6>
      <h6><a [routerLink]="['/customer/favorites']" >Mes Favoris</a></h6>
      <h6><a [routerLink]="['/customer/alerts']" >Mes Alertes</a></h6>
      <!-- <h6><a [routerLink]="['/customer/rent']" fragment="alerts" >Mes alertes({{dealerData.alerts!.length}})</a></h6> -->
    </div>
  }
</mat-expansion-panel>

<mat-expansion-panel expanded>
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h5>Communications</h5>
      <!--
      <button class="simple-button" mat-button routerLink="/customer/rent"><mat-icon>open_in_new</mat-icon>Gérer</button>
      -->
    </mat-panel-title>
  </mat-expansion-panel-header>

  @if (dealerData != undefined) {
    <div>
      <h6><a [routerLink]="['/customer/appointments']">Mes rendez-vous </a></h6>
      <h6><a [routerLink]="['/customer/conversations']">Mes conversations</a></h6>
      <h6><a [routerLink]="['/customer/notifications']">Mes Notifications</a></h6>
    </div>
  }
</mat-expansion-panel>

<mat-expansion-panel expanded>
  <mat-expansion-panel-header>
    <mat-panel-title>


      <h5>Profil</h5>
      <!--
      <button class="simple-button" mat-button routerLink="/customer/rent"><mat-icon>open_in_new</mat-icon>Gérer</button>
      -->

    </mat-panel-title>
  </mat-expansion-panel-header>

  @if (dealerData != undefined) {
    <div>
      <h6><a [routerLink]="['/customer/account']">Mon compte</a></h6>
    </div>
  }
</mat-expansion-panel>

</mat-accordion>

</div>





